<template>
  <v-fade-transition v-if="loading">
    <v-overlay :absolute="absolute" color="white" opacity="0.7">
      <template v-if="text">
        <v-card class="pa-3" width="330px" color="white" v-if="card">
          <v-row style="text-align: center">
            <v-col cols="12"
              ><v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular
            ></v-col>
            <v-col cols="12" class="pb-0"
              ><span class="loading-card-text">{{ text }}</span></v-col
            >
            <v-col cols="12"
              ><span class="loading-card-text">{{ subText }}</span></v-col
            >
          </v-row>
        </v-card>
        <v-row v-else style="text-align: center">
          <v-col cols="12"
            ><v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular
          ></v-col>
          <v-col cols="12" class="pb-0"
            ><span class="loading-text">{{ text }}</span></v-col
          >
          <v-col cols="12"
            ><span class="loading-text">{{ subText }}</span></v-col
          >
        </v-row>
      </template>
      <template v-else-if="dashboard">
         <v-progress-circular
          indeterminate
          size="50"
          color="primary"
        ></v-progress-circular>
      </template>
      <template v-else>
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </template>
    </v-overlay>
  </v-fade-transition>
</template>

<script>
export default {
  name: 'ElOverlayLoading',
  props: {
    card: Boolean,
    dashboard: Boolean,
    text: String,
    subText: String,
    loading: Boolean,
    absolute: { type: Boolean, default: true },
  },
}
</script>

<style lang="scss" scoped>
.loading-text {
  color: #198677;
  width: 300px;
  display: inline-table;
  font-size: 15px;
}
.loading-card-text {
  color: #198677;
  width: 300px;
  display: inline-table;
  font-size: 15px;
}
</style>
